<div id="wdpr-dvic-banner">
    <a href="/visa-card/?trackcode=613F01&mobtrackcode=65HZ01&offer=Save250" *ngIf="this.dvicimage === 'mobile_web'" >
        <img src="https://stage.cdn1.parksmedia.wdprapps.disney.com/media/home/homepage_dvic_banner_mobile_portrait.jpg" 
        class="hidden-md hidden-lg" style="width: 100%;">
    </a>
    <a href="/visa-card/?trackcode=613F01&mobtrackcode=65HZ01&offer=Save250" *ngIf="this.dvicimage === 'web'" >
        <img src="https://stage.cdn1.parksmedia.wdprapps.disney.com/media/home/homepage_dvic_banner_desktop.jpg" 
        class="hidden-xs hidden-sm" style="width: 100%;">
    </a>
</div>